import { inject, Injectable } from '@angular/core';
import {
  type CreateGoalCardInput,
  type GoalCardFilter,
  type GoalCardsQueryQueryVariables,
  type TimelineWithGoalCardsQueryQueryVariables,
  type UpdateGoalCardInput,
} from '@reconcept-platform/shared/types';
import { ToastNotificationsService } from '@reconcept-platform/shared/ui/core/toast-notifications';
import { map, tap } from 'rxjs/operators';
import { GoalCardApi } from '../../../api/goal-card/goal-card.api';

@Injectable({
  providedIn: 'root',
})
export class GoalCardService {
  private goalCardApi = inject(GoalCardApi);
  private toast = inject(ToastNotificationsService);

  watchGoalCardsOverview(goalCardsFilter: GoalCardFilter) {
    return this.goalCardApi.watchGoalCardOverview(goalCardsFilter);
  }

  watchGoalCards(goalCardsFilter: GoalCardsQueryQueryVariables) {
    return this.goalCardApi.watchGoalCards(goalCardsFilter);
  }

  watchGoalCardsForExport(goalCardsFilter: GoalCardFilter) {
    return this.goalCardApi.watchGoalCardsForExport(goalCardsFilter);
  }

  watchGoalWithSubDomain(goalCardId: string) {
    return this.goalCardApi.watchGoalCardWithSubDomain(goalCardId);
  }

  watchTimelineGoalCards(goalCardsFilter: TimelineWithGoalCardsQueryQueryVariables) {
    return this.goalCardApi.watchTimelineGoalCards(goalCardsFilter);
  }

  watchLinkedCards(goalCardId: string) {
    return this.goalCardApi.watchGoalWithLinkedCards(goalCardId).pipe(map((eventCard) => eventCard.linkedCards));
  }

  createGoal(createGoalCardInput: CreateGoalCardInput) {
    return this.goalCardApi.createGoalCard(createGoalCardInput);
  }

  updateGoal(updateGoalCardInput: UpdateGoalCardInput, subDomainId: string) {
    return this.goalCardApi.updateGoalCard(updateGoalCardInput, subDomainId).pipe(
      tap({
        error: (e) =>
          this.toast.errorTranslated({
            titleKey: 'qz-failed-zm',
            messageKey: e?.message ?? 'qz-unexpected-error-has-occurred-please-try-again-zm',
          }),
      }),
    );
  }

  destroyCard(id: string) {
    return this.goalCardApi.destroyCard(id);
  }

  duplicateGoalCard(id: string) {
    return this.goalCardApi.duplicateGoalCard(id);
  }
}
